// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"4e189618","186":"7d9154d1","272":"0de67434","372":"c99c2f19","738":"420cc531","743":"a87fc3c6","815":"0e4d55d2","841":"7404b4ac","851":"880015b1","856":"2581277c"}[chunkId] + ".chunk.js";
};